import * as yup from 'yup';

export const FIELD_IN_RU = 'ru';
export const FIELD_IN_UZ = 'uz';

export const FIELD_TITLE = 'title';
export const FIELD_TITLE_RU = 'title.ru';
export const FIELD_TITLE_UZ = 'title.uz';
export const FIELD_TITLE_OZ = 'title.oz';
export const FIELD_DESCRIPTION = 'description';
export const FIELD_DESCRIPTION_RU = 'description.ru';
export const FIELD_DESCRIPTION_UZ = 'description.uz';
export const FIELD_DESCRIPTION_OZ = 'description.oz';
export const FIELD_ORGANIZATION = 'organization';

export const DirectionsEditValidationForm = yup.object().shape({
  [FIELD_TITLE_RU]: yup.string().trim(),
  [FIELD_TITLE_UZ]: yup.string().trim(),
  [FIELD_TITLE_OZ]: yup.string().trim(),
  [FIELD_DESCRIPTION_RU]: yup.string().trim(),
  [FIELD_DESCRIPTION_UZ]: yup.string().trim(),
  [FIELD_DESCRIPTION_OZ]: yup.string().trim(),
  [FIELD_ORGANIZATION]: yup.string().required('error.required').trim(),
});
